import { createClient } from "@supabase/supabase-js";
import type { Database } from "../types/database";

interface PublicSupabaseConfig {
  publishableKey?: string;
  url?: string;
}

const ENV_CONFIG: PublicSupabaseConfig = {
  url: import.meta.env.VITE_SUPABASE_URL,
  publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
};

export function createAppDataClient(config: PublicSupabaseConfig = ENV_CONFIG) {
  const url = config.url?.trim();
  const publishableKey = config.publishableKey?.trim();

  if (!url || !publishableKey) {
    return { kind: "mock", reason: "missing_public_configuration" } as const;
  }

  return {
    kind: "supabase",
    client: createClient<Database>(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true
      }
    })
  } as const;
}

export type AppDataClient = ReturnType<typeof createAppDataClient>;

export const appDataClient = createAppDataClient();
